module.exports = __webpack_public_path__ + "media/img/apple-touch-icon-iphone4-d009e3927e2101b18b24d1d1255e02fc.png";